<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    title="创建出库单"
    :visible.sync="visible"
    width="840px"
    append-to-body=""
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      label-width="100px"
      :rules="rules"
      :model="orderInfo">
      <el-form-item label="订单号:"> {{ orderInfo.bizOrderCode }} </el-form-item>
      <el-form-item label="发货方式:">
        <span v-if="orderInfo.outType === 0">待定</span>
        <span v-if="orderInfo.outType === 1 && orderInfo.orderFlag === '1'">正常出库</span>
        <span v-if="orderInfo.outType === 1 && orderInfo.orderFlag === '2'">改单出库</span>
        <span v-if="orderInfo.outType === 2 && orderInfo.orderFlag === '3'">空包出库</span>
        <span v-if="orderInfo.outType === 1 && orderInfo.orderFlag === '3'">刷单出库</span>
      </el-form-item>
      <el-form-item
        label="发货仓库:"
        prop="warehouseNo">
        <el-input
          v-model="orderInfo.warehouseName"
          readonly>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="selectWarehouse"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item
        label="物流方式:"
        prop="transType">
        <el-radio-group v-model="orderInfo.transType">
          <el-radio-button :label="1">陆运</el-radio-button>
          <el-radio-button :label="2">空运</el-radio-button>
          <el-radio-button :label="3">自提</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <template v-if="orderInfo.transType !== 3">
        <el-form-item
          label="快递模板:"
          prop="logisticsCode">
          <ent-logistics-select
            v-model="orderInfo.logisticsCode"
            :callback="logisticsSelectCallback"
            :option="{vendorId: userInfo.orgId}" />
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip
              effect="dark"
              content="根据物流模板信息获取">
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span>发件人:</span>
          </div>
          {{ orderInfo.senderName }}-{{ orderInfo.senderMobile }}-{{ orderInfo.senderProvince }}{{ orderInfo.senderCity }}{{ orderInfo.senderDistrict }}{{ orderInfo.senderAddress }}
        </el-form-item>
      </template>
      <el-form-item
        label="收件人姓名:"
        prop="receiverName">
        <el-input v-model="orderInfo.receiverName"></el-input>
      </el-form-item>
      <el-form-item
        label="收件人手机:"
        prop="receiverMobile">
        <el-input v-model="orderInfo.receiverMobile"></el-input>
      </el-form-item>
      <el-form-item
        label="收件人电话:"
        prop="receiverTel">
        <el-input v-model="orderInfo.receiverTel"></el-input>
      </el-form-item>
      <el-form-item
        :required="orderInfo.transType !== 3"
        style="margin-bottom:0"
        label="收件省市区:">
        <el-row :gutter="0">
          <el-col :span="7">
            <el-form-item
              label-width="0"
              prop="receiverProvince">
              <el-input v-model="orderInfo.receiverProvince"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="7"
            :offset="1">
            <el-form-item
              label-width="0"
              prop="receiverCity">
              <el-input v-model="orderInfo.receiverCity"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="7"
            :offset="1">
            <el-form-item
              label-width="0"
              prop="receiverDistrict">
              <el-input v-model="orderInfo.receiverDistrict"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item
        label="收件地址:"
        prop="receiverAddress">
        <el-input v-model="orderInfo.receiverAddress"></el-input>
      </el-form-item>
      <el-form-item
        v-if="orderInfo.remark"
        label="备注:"> {{ orderInfo.remark }}</el-form-item>
      <el-form-item
        v-loading="orderInfo.outType === 2"
        class="loading-wrap"
        element-loading-text="空包"
        element-loading-spinner="el"
        element-loading-background="rgba(255, 255, 255, 0.7)"
        label="待发货明细:"
        prop="detailList">
        <el-table
          v-loading="loading"
          :row-style="rowStyle"
          max-height="400px"
          :data="orderInfo.detailList"
          border>
          <el-table-column
            :resizable="false"
            label="商品名称"
            prop="skuName">
            <template slot-scope="{row}">
              {{ row.skuName || row.productName }}
              <el-tag v-if="row.isFree === 1">赠</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            label="商品编码"
            width="80"
            prop="skuCode"></el-table-column>
          <el-table-column
            label="下单数量"
            width="70"
            :resizable="false"
            prop="num">
            <template slot-scope="{row}">{{ row.num }} {{ row.measureUnit | measureUnitName() }}</template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            width="100"
            label="出库单">
            <el-table-column
              :resizable="false"
              width="70"
              label="已生成"
              prop="outNum">
              <template slot-scope="{row}">{{ row.outNum }} {{ row.measureUnit | measureUnitName() }}</template>
            </el-table-column>
            <el-table-column
              :resizable="false"
              width="70"
              label="待生成"
              prop="needOut">
              <template slot-scope="{row}">{{ row.needOut }} {{ row.measureUnit | measureUnitName() }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="出库数量"
            :resizable="false"
            prop="num">
            <template slot-scope="{row,$index}">
              <el-form-item
                style="margin-bottom:0"
                label-width="0"
                :prop="'detailList.' + $index + '.tempnum'">
                <el-popover
                  v-if="orderInfo.source!== 7"
                  placement="top"
                  title="库存"
                  trigger="hover">
                  <div style="font-size: 12px;">
                    <div>仓库：{{ row.warehouse.warehouseNo | warehouseName() }}</div>
                    <div>库存：{{ row.warehouse.num }}</div>
                  </div>
                  <el-input-number
                    slot="reference"
                    v-model="orderInfo.detailList[$index].tempnum"
                    style="width: 100%"
                    :precision="0"
                    :max="row.maxNum"
                    :min="0"></el-input-number>
                </el-popover>
                <el-input-number
                  v-else
                  v-model="orderInfo.detailList[$index].tempnum"
                  style="width: 100%"
                  :precision="0"
                  :max="row.maxNum"
                  :min="0"></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="fetchCombineList">确 定</el-button>
    </div>
    <warehouse-select-modal
      ref="warehouse"
      :callback="warehouseCallback" />
    <combine-order-modal
      ref="combine"
      :callback="addOut"
      @toggleLoading="(bool)=> loading = bool" />
  </el-dialog>
</template>
<script>
import WarehouseSelectModal from './warehouse-select-modal.vue'
import EntLogisticsSelect from '../../../components/business/ent-logistics-select.vue'

import { mapState } from 'vuex'
import _ from 'lodash'
import CombineOrderModal from './combine-order-modal.vue'
export default {
  name: 'OrderOutModal',
  components: { WarehouseSelectModal, EntLogisticsSelect, CombineOrderModal },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      salesOrderId: null,
      orderInfo: {
        bizOrderId: null,
        bizOrderCode: null,
        ownerCode: null,
        orderFlag: 1,
        outType: 0,
        type: 21,
        warehouseNo: null,
        transType: 1,
        packageNum: 1,
        logisticsCode: null,
        senderName: '',
        senderProvince: '',
        senderCity: '',
        senderDistrict: '',
        senderAddress: '',
        senderMobile: '',
        receiverName: '',
        receiverMobile: '',
        receiverTel: '',
        receiverProvince: '',
        receiverCity: '',
        receiverDistrict: '',
        receiverAddress: '',
        detailList: [],
        source: null
      },
      visible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      warehouse: state => state.account.warehouse
    }),
    rules() {
      const { receiverMobile, receiverTel, transType } = this.orderInfo
      return {
        warehouseNo: [{ required: true, message: '请选择发货仓库', trigger: 'change' }],
        transType: [{ required: true, message: '请选择发货方式', trigger: 'change' }],
        logisticsCode: [{ required: true, message: '请选择物流公司', trigger: 'change' }],
        packageNum: [{ required: true, message: '请输入包裹数量', trigger: 'blur' }],
        receiverName: [{ required: true, message: '请输入收件人姓名', trigger: 'blur' }],
        receiverMobile: [{ required: transType !== 3 && (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'blur' }],
        receiverTel: [{ required: transType !== 3 && (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'blur' }],
        receiverProvince: [{ required: transType !== 3, message: '请输入收件省份', trigger: 'blur' }],
        receiverCity: [{ required: transType !== 3, message: '请输入收件城市', trigger: 'blur' }],
        receiverDistrict: [{ required: transType !== 3, message: '请输入收件区县', trigger: 'blur' }],
        receiverAddress: [{ required: transType !== 3, message: '请输入收件地址', trigger: 'blur' }]
      }
    }
  },
  methods: {
    rowStyle({ row }) {
      return {
        'background-color': row.tempnum < row.needOut ? 'rgb(253, 246, 236)' : ''
      }
    },
    fetchCombineList() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const detailList = this.orderInfo.detailList.filter(s => s.tempnum > 0)
          if (detailList.length === 0) {
            this.$message.error('出库数量不能为空')
            return
          }
          if ((detailList.length < this.orderInfo.detailList.length) || detailList.some(i => i.tempnum < i.needOut)) {
            this.$confirm('本次建单中，部分商品的发货数量与其待发货数量不一致，将会分批发货，是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$refs.combine.fetch(this.formatPostData())
            })
          } else {
            this.$refs.combine.fetch(this.formatPostData())
          }
        }
      })
    },
    formatPostData() {
      const { bizOrderId,
        bizOrderCode,
        warehouseNo,
        ownerCode,
        outType,
        type,
        logisticsCode: expressCode,
        packageNum,
        receiverName,
        receiverMobile,
        receiverTel,
        receiverProvince,
        receiverCity,
        receiverDistrict,
        receiverAddress,
        transType,
        detailList
      } = this.orderInfo
      return {
        bizOrderId,
        bizOrderCode,
        warehouseNo,
        ownerCode,
        outType,
        type, // 'int //单据类型 XSCK(21, "销售出库"), PDCK(22, "盘点出库"), DBCK(23, "调拨出库"), SCCK(24, "调拨出库"), QTCK(99, "其他出库");
        expressCode,
        packageNum,
        receiverName,
        receiverMobile,
        receiverTel,
        receiverProvince,
        receiverCity,
        receiverDistrict,
        receiverAddress,
        transType,
        detailList: detailList.filter(s => s.tempnum > 0).map(s => {
          return {
            // outOrderId: bizOrderId,
            bizOrderDetailId: s.id, // 业务单明细id',
            skuId: s.skuId,
            num: s.tempnum,
            stockId: s.warehouse.id// 库存id,仓库库存Id【必须】',
          }
        })
      }
    },
    toggleModal(visible) {
      this.visible = visible
    },
    logisticsSelectCallback(row) {
      this.orderInfo.senderName = row.senderName
      this.orderInfo.senderProvince = row.senderProvinceName
      this.orderInfo.senderCity = row.senderCityName
      this.orderInfo.senderDistrict = row.senderAreaName
      this.orderInfo.senderAddress = row.senderAddress
      this.orderInfo.senderMobile = row.senderPhone
    },
    handleClosed() {},
    addOut(addType) {
      this.loading = true
      this.$store.dispatch('outstock/outsendadd', {
        payload: {
          ...this.formatPostData(),
          addType
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.callback && this.callback()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    selectWarehouse() {
      this.$refs.warehouse.fetch({
        departmentId: this.orderInfo.ownerCode
      })
    },
    warehouseCallback(row) {
      this.orderInfo.warehouseNo = row.warehouseNo
      this.orderInfo.warehouseName = row.warehouseName
      if (this.orderInfo.outType !== 2 && this.orderInfo.source !== 7) {
        this.getstocklist(this.orderInfo.warehouseNo, this.orderInfo.detailList.map(i => i.skuId))
      }
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/salesdetail', {
        payload: {
          salesOrderId: this.salesOrderId
        },
        success: res => {
          this.loading = false
          const data = res.data.data
          res.data.data.detailList.forEach(i => {
            i.needOut = i.num - i.outNum
            i.maxNum = i.num - i.outNum
            i.tempnum = data.outType === 2 || data.source === 7 ? i.num - i.outNum : 0
            i.warehouse = { skuId: i.skuId, id: null, num: 0 }
          })
          this.$set(this, 'orderInfo', {
            ...this.orderInfo,
            bizOrderId: data.id,
            bizOrderCode: data.code,
            ownerCode: data.ownerCode,
            orderFlag: data.orderFlag,
            outType: data.outType,
            type: 21,
            source: data.source,
            warehouseNo: data.warehouseNo,
            warehouseName: (this.warehouse.find(i => i.warehouseNo === data.warehouseNo) || {}).warehouseName,
            transType: data.transType,
            packageNum: 1,
            logisticsCode: !!data.logisticsCode && !!(+data.logisticsCode) ? +data.logisticsCode : null,
            senderName: data.senderName,
            senderProvince: data.senderProvince,
            senderCity: data.senderCity,
            senderDistrict: data.senderDistrict,
            senderAddress: data.senderAddress,
            senderMobile: data.senderMobile,
            receiverName: data.receiverName,
            receiverMobile: data.receiverMobile,
            receiverTel: data.receiverTel,
            receiverProvince: data.receiverProvince,
            receiverCity: data.receiverCity,
            receiverDistrict: data.receiverDistrict,
            receiverAddress: data.receiverAddress,
            detailList: data.detailList.filter(i => i.needOut > 0)
          })
          if (data.outType !== 2 && data.source !== 7) {
            this.getstocklist(this.orderInfo.warehouseNo, this.orderInfo.detailList.map(i => i.skuId))
          }
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getstocklist(warehouseNo, skuIdList) {
      this.$store.dispatch('outstock/stocklist', {
        payload: {
          pageNum: 1,
          pageSize: 1000,
          warehouseNo,
          skuIdList
        },
        success: (res) => {
          console.log(res)
          const records = res.data.data.records
          this.loading = false
          const detailList = _.cloneDeep(this.orderInfo.detailList)
          detailList.forEach(i => {
            const item = records.find(s => s.skuId === i.skuId) || { skuId: i.skuId, warehouseNo, id: null, num: 0 }
            i.warehouse = item
            i.maxNum = i.needOut > item.num ? item.num : i.needOut
            i.tempnum = i.maxNum
          })
          this.$set(this.orderInfo, 'detailList', detailList)
        },
        fail: () => {
          this.loading = false
          const records = []
          const detailList = _.cloneDeep(this.orderInfo.detailList)
          detailList.forEach(i => {
            const item = records.find(s => s.skuId === i.skuId) || { skuId: i.skuId, warehouseNo, id: null, num: 0 }
            i.warehouse = item
            i.maxNum = i.needOut > item.num ? item.num : i.needOut
            i.tempnum = i.maxNum
          })
          this.$set(this.orderInfo, 'detailList', detailList)
        }
      })
    },
    fetch(salesOrderId) {
      if (this.loading) {
        return
      }
      this.salesOrderId = salesOrderId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus">
.loading-wrap {
  .el-loading-text {
    font-size: 20px;
    color: #333
  }
}
</style>
